import React from 'react'
import {
  ImpactSection,
  ImpactIntro,
  ImpactEyebrow,
  ImpactHeading,
  ImpactCopy,
  StatsGrid,
  Stat,
  StatValue,
  StatLabel,
  SourceLink,
} from './impact-stats.styles'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'

export function ImpactStats({ data }) {
  return (
    <ImpactSection {...analyticsModuleAttributes(data, 'impact_stats', undefined, data.header)}>
      <ImpactIntro>
        {data.eyebrow && <ImpactEyebrow>{data.eyebrow}</ImpactEyebrow>}
        <ImpactHeading>{data.header}</ImpactHeading>
        {data.intro && <ImpactCopy>{data.intro}</ImpactCopy>}
      </ImpactIntro>
      <StatsGrid>
        {data.stats?.map((stat) => (
          <Stat key={stat._key || `${stat.value}-${stat.label}`}>
            <StatValue>{stat.value}</StatValue>
            <StatLabel>{stat.label}</StatLabel>
          </Stat>
        ))}
      </StatsGrid>
      {data.sourceUrl && (
        <SourceLink href={data.sourceUrl} target="_blank" rel="noopener noreferrer">
          {data.sourceLabel || 'View source'}
        </SourceLink>
      )}
    </ImpactSection>
  )
}

export default ImpactStats
